import { TrainIcon } from './TrainIcon';

/**
 * author: Google
 * id B6E1232A-3A43-4200-BE34-1BC436B34BF1
 * name train
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/train.svg
 * tags
 * - Navigation 
 * - Transportation + Other 
 */
export const DirectionsRailwayIcon = TrainIcon;
export default DirectionsRailwayIcon